import React from 'react';
import { Box, Typography, Grid, CardContent } from '@mui/material';
import './Shimmer.css'; // Import the shimmer styles

const ShimmerBox = ({ width, height, sx }) => (
    <Box className="shimmer" sx={{ width, height, ...sx }} />
);

export default function RestaurantProfileShimmer() {
    return (
        <Box sx={{ px: 0 }}>
            {/* Hero Section */}
            <Box
                sx={{
                    position: 'relative',
                    height: { xs: 400, md: 480 },
                    borderRadius: 3,
                    overflow: 'hidden',
                    mb: 6,
                    pt: 0,
                    backgroundColor: '#f0f0f0',
                }}
            >
                <ShimmerBox width="100%" height="100%" />
                <Box
                    sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'flex-start',
                        px: { xs: 3, md: 8 },
                    }}
                >
                    <ShimmerBox width="60%" height={48} sx={{ mb: 2 }} />
                    <ShimmerBox width="80%" height={24} sx={{ mb: 3 }} />
                    <ShimmerBox width="40%" height={20} sx={{ mb: 1 }} />
                    <ShimmerBox width="40%" height={20} sx={{ mb: 2 }} />
                    <Box sx={{ display: 'flex', gap: 2 }}>
                        <ShimmerBox width={120} height={40} />
                        <ShimmerBox width={120} height={40} />
                    </Box>
                </Box>
            </Box>

            {/* About Section */}
            <Box sx={{ mb: 6, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <ShimmerBox width="80%" height={24} sx={{ mb: 2 }} />
                <ShimmerBox width="60%" height={20} sx={{ mb: 1 }} />
                <ShimmerBox width="60%" height={20} sx={{ mb: 1 }} />
            </Box>

            {/* Featured Dishes Section */}
            <Box>
                <Typography variant="h6" gutterBottom>
                    Menu
                </Typography>
                <Box sx={{ display: 'flex', overflowX: 'auto', gap: 2, py: 1, px: 1 }}>
                    {[...Array(6)].map((_, index) => (
                        <Box key={index} sx={{ minWidth: 240, flex: '0 0 auto' }}>
                            <Box sx={{ border: '1px solid #e0e0e0', borderRadius: 2, overflow: 'hidden' }}>
                                <ShimmerBox width="100%" height={140} />
                                <CardContent sx={{ textAlign: 'center' }}>
                                    <ShimmerBox width="80%" height={24} sx={{ mb: 1, mx: 'auto' }} />
                                    <ShimmerBox width="90%" height={40} sx={{ mb: 2, mx: 'auto' }} />
                                    <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mt: 1 }}>
                                        <ShimmerBox width={50} height={20} />
                                        <ShimmerBox width={70} height={24} />
                                    </Box>
                                </CardContent>
                            </Box>
                        </Box>
                    ))}
                </Box>
            </Box>
        </Box>
    );
}
